function MovieSkeleton() {
  return (
    <div className="movie-card skeleton-card">
      <div className="skeleton skeleton-poster" />
      <div className="skeleton skeleton-title" />
      <div className="skeleton skeleton-text" />
      <div className="skeleton skeleton-text short" />
    </div>
  );
}

export default MovieSkeleton;
